/* eslint-disable no-undef */
import { Store } from 'pullstate';

const ModalStore = new Store({
  photoModal: {
    open: false,
    data: { photo: {} },
  },
  residentModal: {
    open: false,
    data: { resident: {} },
  },
  residentPhotoModal: {
    open: false,
  },
  roomModal: {
    open: false,
    data: { room: {} },
  },
  roomPhotoModal: {
    open: false,
    data: { photo: {} },
  },
  phoneModal: {
    open: false,
    data: { phone: {} },
  },
  profileElementModal: {
    open: false,
    data: {},
  },
  systemMessageModal: {
    open: false,
    data: { subjectId: '', subjectName: '' },
  },
  contactUsModal: {
    open: false,
    data: {},
  },
  emailVerificationModal: {
    open: false,
    data: {},
  },
  policyOrAgreementModal: {
    open: false,
    data: {},
  },
  userBankInfoModal: {
    open: false,
    data: {},
  },
  userProfileModal: {
    open: false,
    data: {},
  },
  residentDocumentsModal: {
    open: false,
    data: {},
  },
  trainingCertificateModal: {
    open: false,
    data: {},
  },
  personalNeedsModal: {
    open: false,
    data: {},
  },
  stayDestinationModal: {
    open: false,
    data: {},
  },
});

export const openModal = (state, modal, data) => {
  state[`${modal}Modal`].open = true;

  const element = document.getElementById(`${modal}Modal`);
  const bootstrapModal = new bootstrap.Modal(element, { backdrop: 'static', keyboard: false });

  bootstrapModal.show();

  state[`${modal}Modal`].instance = bootstrapModal;

  if (!data) return;

  state[`${modal}Modal`].data = data;
};

export const closeModal = (state, modal, data) => {
  if (state[`${modal}Modal`].instance) {
    state[`${modal}Modal`].instance.hide();
  }

  state[`${modal}Modal`].open = false;

  if (!data) return;

  state[`${modal}Modal`].data = data;
};

export default ModalStore;
